var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "module-template" },
    [
      _c("el-cascader", {
        attrs: {
          size: _vm.size,
          "collapse-tags": "",
          options: _vm.options,
          props: _vm.props,
          placeholder: _vm.placeholder,
          clearable: "",
          filterable: "",
          "show-all-levels": _vm.showAllLevels,
          disabled: _vm.disabled,
        },
        on: {
          change: function ($event) {
            return _vm.change(_vm.insValue)
          },
        },
        model: {
          value: _vm.insValue,
          callback: function ($$v) {
            _vm.insValue = $$v
          },
          expression: "insValue",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }